import formFieldCommonOptions from 'foundation/js/formFieldCommonOptions'
import Editor from '@tinymce/tinymce-vue'

const options = formFieldCommonOptions('FormInputRichText', {})

options.components.Editor = Editor

export default options